import { motion } from 'framer-motion';
import { useState } from 'react';
import { Plus } from 'lucide-react';
import { Reveal } from '../../ui/Reveal/Reveal';
import { services } from '../../../data/services';
import './Services.css';

export function Services() {
  const [open, setOpen] = useState<string | null>(services[0].id);

  return (
    <section id="services" className="section services">
      <div className="container">
        <div className="services__head">
          <Reveal>
            <span className="eyebrow">What we do</span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="services__title display-lg">
              An end-to-end studio,<br />
              <span className="italic-accent">one accountable team.</span>
            </h2>
          </Reveal>
        </div>

        <div className="services__list">
          {services.map((s, i) => {
            const isOpen = open === s.id;
            return (
              <Reveal key={s.id} delay={i * 0.06}>
                <div
                  className={`service ${isOpen ? 'service--open' : ''}`}
                  onClick={() => setOpen(isOpen ? null : s.id)}
                  data-cursor="hover"
                >
                  <div className="service__row">
                    <span className="service__num">{s.number}</span>
                    <h3 className="service__title">{s.title}</h3>
                    <motion.div
                      className="service__plus"
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                    >
                      <Plus size={22} strokeWidth={1.25} />
                    </motion.div>
                  </div>

                  <motion.div
                    className="service__body"
                    initial={false}
                    animate={{
                      height: isOpen ? 'auto' : 0,
                      opacity: isOpen ? 1 : 0,
                    }}
                    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                  >
                    <div className="service__body-inner">
                      <p className="service__desc">{s.description}</p>
                      <ul className="service__caps">
                        {s.capabilities.map((c) => (
                          <li key={c}>
                            <span className="service__caps-dot" />
                            {c}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </motion.div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
